<template>
<div>
    <div class="com-model company-base flex align-initial m-b-15 relative">
        <div class="cy-logo" @mouseover="overShow" @mouseout="outHide">
            <img :src="companyInfo.logo" alt="logo">
            <div class="upload-btn">更改LOGO</div>
            <input type="file" @change="logoChange" class="ch-inp">
        </div>
        <div class="flex flex-column flex-between align-start">
            <div class="cy-title ">{{companyInfo.shortName}}</div>
            <div >
                <div class="flex long-name">
                    <img style="width: 24px; height: 24px;margin-right: 8px" src="../../assets/images/company/title_icon.png" />
                    {{companyInfo.name}}
                </div>
                <div class="flex detail" >
                    <div class="flex" style="margin-right: 24px">
                        <img style="width: 16px; height: 16px; margin-right: 8px;" src="../../assets/images/company/hangye_icon.png"/>
                        {{companyInfo.industryName}}
                    </div>
                    <div class="flex" style="margin-right: 24px">
                        <img style="width: 16px; height: 16px; margin-right: 8px;" src="../../assets/images/company/user_icon.png"/>
                        {{companyInfo.scale}}
                    </div>
                </div>
            </div>
        </div>
        <router-link :to="{
            path: '/index/company/base'
        }" class="primary-btn right-btn" >编辑</router-link>
    </div>
    <div class="com-model m-b-15 relative company-location">
        <div class="com-title m-b-20">公司位置</div>
        <div class="flex align-start warp">
            <div>
                <div class="flex company-in-title">
                    <img class="icon" src="../../assets/images/company/position_icon.png"/>
                    {{companyInfo.cityName}} {{companyInfo.areaName}}
                </div>
                <div class="company-in-detail">
                     {{companyInfo.provinceName}} {{companyInfo.cityName}} {{companyInfo.areaName}} {{companyInfo.address}}
                </div>
            </div>
            <div class="map" id="container"></div>
        </div>
        <router-link :to="{
            path: '/index/company/base',
            query: {
                type: 'location'
            }
        }" class="primary-btn right-btn" >编辑</router-link>
    </div>
    <div class="com-model company-license relative">
        <div class="com-title " :class="{'m-b-20':!!this.companyInfo.license}">工商信息</div>
        <div class="flex">
            <div class="renzheng-img" v-if="this.companyInfo.licenseImg">
                <img :src="companyInfo.licenseImg" alt="license" >
                <div class="license-auth flex flex-center" v-if="this.companyInfo.isAuth == 1">
                    <img src="../../assets/images/company/auth_icon.png" />
                </div>
            </div>
            <div>
                <div class="flex company-in-title">
                    <img class="icon" src="../../assets/images/company/title_icon.png"/>
                    企业名称
                </div>
                <div class="company-in-detail">
                     {{companyInfo.name}}
                </div>

                <div class="flex company-in-title">
                    <img class="icon" src="../../assets/images/company/daima_icon.png"/>
                    信用代码
                </div>
                <div class="company-in-detail">
                    {{companyInfo.license}}
                </div>
            </div>
        </div>
        <div class="right-btn flex" v-if="this.companyInfo.isAuth != 1">
            <span style="color: #FF7A45; font-size: 20px; margin-right: 20px;" v-if="this.companyInfo.license"> {{this.companyInfo.authStatus == 0 ? '待审核' : this.companyInfo.authStatus == -1 ? '审核未通过' : '已认证'}} </span>
            <router-link :to="{
                path: '/index/company/auth'
            }" class="primary-btn "  v-if="!this.companyInfo.license || this.companyInfo.authStatus == -1">{{!this.companyInfo.license ? '去认证':'重新提交' }}</router-link>
        </div>
    </div>
</div>
</template>
<script>
const qs = require("qs");
export default {
    data(){
        return {
            companyInfo:{},
            name: '',
            shortName:'',
            scale:'',
            industryName:'',
            address:'',
            description:'',
            logoUrl:'',
            backgroundUrl:'',
            scaleList:[],
            industryList:[],
            telephone:'',
            showUploadMask: false,
        }
    },
    created(){
        this.getInfo();
        // this.getIndustryList();
    },
    methods:{
        //模拟hover效果   鼠标放在头像显示上传按钮
        overShow () {
            this.showUploadMask = !this.showUploadMask;
        },
        outHide () {
            this.showUploadMask = !this.showUploadMask;
        },
        //end
        getInfo(){
            let url = '/wapi/company/get';
            this.axios.get(url).then(res => {
                if(res.success){
                    const data = res.data
                    this.companyInfo = data;
                    let center = new TMap.LatLng(data.lat, data.lng);
                    this.map = new TMap.Map("container", {
                        zoom: 17,
                        center: center,
                    });
                    new TMap.MultiMarker({
                        map: this.map,
                        geometries: [
                            {
                                position: center,
                                id: 'marker',
                            },
                        ]
                    });
                }
                // let rdata = res.data;
                // this.name = rdata.name;
                // this.shortName = rdata.shortName;
                // this.scale = rdata.scale;

                // this.industryName = rdata.industryName + '-' + rdata.industryId;

                // this.address = `${rdata.provinceName} ${rdata.cityName} ${rdata.areaName} ${rdata.address}` ;
                // this.description = rdata.description;
                // this.logoUrl = rdata.logo;
                // this.backgroundUrl = rdata.backgroundImage;
                // this.telephone = rdata.telephone
            })
        },

        modifyTelephone(){
            let url = '/wapi/company/modifyTelephone';
            let param ={
                telephone: this.telephone
            }
            this.axios.post(url,qs.stringify(param)).then(res => {
                if(res.success){
                    this.$message({
                        type:'success',
                        message:'企业联系电话修改成功'
                    })
                }
            })
        },
        modifyShortName(){
            let url = '/wapi/company/modifyShortName';
            let param ={
                shortName: this.shortName
            }
            this.axios.post(url,qs.stringify(param)).then(res => {
                if(res.success){
                    this.$message({
                        type:'success',
                        message:'企业名称修改成功'
                    })
                }
            })
        },
        modifyIndustry(){
          let url = '/wapi/company/modifyIndustry';
          let param ={
            industryName: this.industryName.split('-')[0],
            industryId: this.industryName.split('-')[1]
          }
          this.axios.post(url,qs.stringify(param)).then(res => {
              if(res.success){
                  this.$message({
                      type:'success',
                      message:'企业类型修改成功'
                  })
              }
          })
        },
        getScale(){
            let url = '/baseData/listScale';
            this.axios.get(url).then(res => {
                if(res.success){
                    this.scaleList = res.data;
                }
            })
        },
        modifyAddress(){
            let url = '/wapi/company/modifyAddress';
            this.axios.post(url,qs.stringify({address: this.address})).then(res => {
                if(res.success){
                    this.$message({
                        type:'success',
                        message:'企业地址修改成功'
                    })
                }
            })
        },
        //修改企业简介
        modifyDescription(){

            let url = '/wapi/company/modifyDescription';
            let param = {
                description: this.description
            }
            this.axios.post(url,qs.stringify(param)).then(res => {
                if(res.success){
                    this.$message({
                        type:'success',
                        message:'企业简介修改成功'
                    })
                }
            })
        },
        logoChange(event){
            let formdata = new FormData();
            formdata.append('logoFile',event.target.files[0]);
            this.axios.post('/wapi/base/upload/logo',formdata)
            .then(res =>{
                if(res.status*1 == 200){
                    this.companyInfo.logo = res.data;
                    let urlModify = `/wapi/company/modifyLogo?logo=${this.companyInfo.logo}`;
                     this.axios.get(urlModify).then(res => {
                         this.$store.state.hrinfo.companyLogo = this.companyInfo.logo;
                         if(res.success){
                            this.$message({
                                type:'success',
                                message:'修改成功'
                            })
                        }
                    })
                }
            })



        },
        modifyScale(){
            let param = {
                scale: this.scale
            }
            this.axios.post('/wapi/company/modifyScale',qs.stringify(param)).then(res => {
                if(res.success){
                    this.$message({
                        type:'success',
                        message:'修改成功'
                    })
                }
            })
        },
        getIndustryList(){
            this.axios.get('/wapi/baseData/listIndustry').then(res => {
                if(res.success){
                    this.industryList = res.data;
                }
            })
        },
        quanjingChange(event){
            let formdata = new FormData();
            formdata.append('backgroundImageFile',event.target.files[0]);
            this.axios.post('/wapi/base/upload/backgroundImg',formdata)
            .then(res => {
                if(res.status*1 == 200){
                    this.backgroundUrl = res.data;
                    this.axios.get(`/wapi/company/modifyBkimg?backgroundImage=${this.backgroundUrl}`).then(res => {
                        if(res.success){
                            this.$message({
                                type:'success',
                                message:'修改成功'
                            })
                        }
                    })
                }
            })
        },
    }
}
</script>
<style scoped lang="less">
@import url('../../assets/less/base.less');
// @import "../../assets/css/company";
.com-model {
    border-radius: 10px;
}
.right-btn{
    top: 18px;
    right: 28px;
    position: absolute;
}
.primary-btn{
    width: 104px;
}
.company-base{
    padding: 18px 24px;
    .cy-logo{
        width: 144px;
        height: 144px;
        border-radius: 4px;
        margin-right: 40px;
        position: relative;
        img{
            width: 100%;
            height: 100%;
        }
        .ch-inp{
            opacity: 0;
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            cursor: pointer;
            z-index: 9
        }
        .upload-btn{
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            background: rgba(0,0,0,0.5);
        }
    }
    .cy-title{
        line-height: 33px;
        font-size: 24px;
        color: #262626;
    }
    .long-name{
        color: #262626;
        font-size: 20px;
        margin-bottom: 12px;
    }
    .detail{
        font-size: 16px;
        color: #333333;
    }
}
.company-location{
    padding: 23px 24px 28px;
    .map-box{
        width: 458px;
        height: 267px;
        border-radius: 8px;
        margin-right: 35px;
    }

    .warp {
        flex-wrap: wrap;
        justify-content: center;
    }

    .map {
        width: 60%;
        margin: 20px 20%;
    }

}
 .company-in-title{
    padding-top: 30px;
    font-size: 24px;
    color: #057CF9;
    font-weight: 400;
    line-height: 33px;
    margin-bottom: 12px;
    .icon{
        width: 24px;
        height: 24px;
        margin-right: 16px;
    }
}
.renzheng-img{
    width: 458px;
    height: 267px;
    margin-right: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    img{
        max-width: 100%;
        max-height: 100%;
    }
    .license-auth{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        img{
            width:170px;
            height: 170px;
        }
    }
}
.company-in-detail{
    font-size: 20px;
    color: #262626;
}
.company-license{
    padding: 23px 27px 28px;

}
.cy-item-xg .iconfont{
    font-size: 14px;
}
.company-content .cy-item-xg span{
    color: #495fcd;
}
.company-content .cy-item-xg{
    width: 58px;
    float: right;
}
.cy-item-inp{
    height: 54px;
}
</style>



// WEBPACK FOOTER //
// company.vue?b92089fa